<template>
  <pack>
    <zt-title class="mb24">订单管理</zt-title>

    <!-- 订单切换 -->
    <div class="typeTab">
      <div
        class="tab-box"
        v-for="item in typeTabList"
        :key="item.name"
        @click="typeTabChange(item)"
        @mouseenter="item.hover = true"
        @mouseleave="item.hover = false"
      >
        <div class="tab-item" :class="item.name==orderType?item.name:item.name+'-hover'">
          <svg-icon :icon="(item.name==orderType||item.hover)?item.icon:item.icon+'_n'"></svg-icon>
          <span>{{item.title}}订单</span>
        </div>
      </div>
    </div>

    <!-- 查询表单 -->
    <el-form @submit.native.prevent>
      <el-date-picker
        type="daterange"
        v-model="date"
        v-bind="datePickerBind"
        @change="onDatePickerChange"
        class="mr16 mb8"
      />

      <zt-form-item label="订单号：" class="mr16 mb8">
        <zt-input max-width="300px" placeholder="请输入订单号" v-model.trim="form.trade_id" />
      </zt-form-item>

      <zt-form-item label="手机号：" class="mr16 mb8">
        <zt-input max-width="300px" placeholder="请输入手机号" v-model.trim="form.telephone" />
      </zt-form-item>

      <zt-button
        type="primary"
        class="mr16 mb8"
        :loading="formLoading"
        @click.enter.exact="onSubmit"
        native-type="submit"
        width="80px"
      >搜索</zt-button>
      <zt-button class="mr16 mb8" :loading="formLoading" @click="onReset" width="80px">清空</zt-button>
    </el-form>
    <!-- 查询表单 -->

    <el-tabs @tab-click="onTabChange" :value="current" type="card" class="mt24">
      <el-tab-pane v-for="(o, i) of tabItems" :key="i" :label="o.cn + `(${ o.count })`" />
    </el-tabs>

    <el-table :data="list" size="medium">
      <el-table-column label="订单编号" prop="trade_parent_id" min-width="74px" />
      <el-table-column label="商品名称" prop="item_title" min-width="150px" />
      <el-table-column label="状态" prop="tk_status" min-width="50px">
        <span slot-scope="{ row }">{{ status2cn(row) }}</span>
      </el-table-column>
      <el-table-column label="付款金额" prop="alipay_total_price">
        <span slot-scope="{ row }">￥{{row.alipay_total_price | toFixed}}</span>
      </el-table-column>
      <el-table-column label="数量" prop="item_num" min-width="40px" />
      <el-table-column label="佣金比例" prop="total_commission_rate" min-width="70">
        <span slot-scope="{ row }">
          <template v-if="orderType === 'taobao'">{{ row.income_rate | toPercentum }}%</template>
          <template v-else>{{ row.total_commission_rate | toPercentum }}%</template>
        </span>
      </el-table-column>
      <el-table-column label="预估佣金" prop="commission">
        <span slot-scope="{ row }">
          {{ row.pub_share_pre_fee ? '￥'+row.pub_share_pre_fee : '￥'+row.pub_share_pre_fee }}
        </span>
      </el-table-column>
      <el-table-column label="买家佣金" prop="owner_cms_member_commission">
        <span slot-scope="{ row }">￥{{ row.owner_cms_member_commission }}</span>
      </el-table-column>
      <el-table-column label="上级佣金" prop="buyer_inv1_cms_member_commission">
        <span slot-scope="{ row }">￥{{ row.buyer_inv1_cms_member_commission }}</span>
      </el-table-column>
      <el-table-column label="上上级佣金" prop="buyer_inv2_cms_member_commission" width="100px">
        <span slot-scope="{ row }">￥{{ row.buyer_inv2_cms_member_commission }}</span>
      </el-table-column>
      <el-table-column label="下单时间" width="75px">
        <div slot-scope="{ row }">{{ row.create_time_ymd }}<br />{{ row.create_time_hms }}</div>
      </el-table-column>
      <el-table-column label="结算时间" width="75px">
        <span slot-scope="{ row }">{{ row.commission_time_ymd}}<br />{{ row.commission_time_hms}}</span>
      </el-table-column>
      <el-table-column label="会员" min-width="100px">
        <span slot-scope="{ row }">
        {{ row.sc_order_type == 0?(row.owner_cms_member_nickname || row.owner_cms_member_telephone || '-'):'-' }}
        </span>
      </el-table-column>
      <el-table-column label="代理" min-width="100px">
        <span slot-scope="{ row }">
        {{ row.sc_order_type == 1?(row.owner_cms_member_nickname || row.owner_cms_member_telephone || '-'):'-' }}
        </span>
      </el-table-column>
      <el-table-column label="PID" prop="pid" v-if="orderType=='jd'" min-width="100px"></el-table-column>
      <el-table-column label="操作" fixed="right" v-if="vip >= 3" min-width="90px">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" @click="onAssignItem(row)">指派</el-button>
 
          <template v-if="(orderType !== 'duomai' && row.tk_status !== 3) || (orderType === 'duomai' && row.tk_status !== 2)">
            <el-button size="mini" @click="onSettlement(row)">提前结算</el-button>
          </template>

          <!-- <zt-button size="mini" @click="onRefreshItem(row)">刷新</zt-button> -->
          <!-- <zt-button size="mini" type="danger" @click="onDeleteItem(row)">删除</zt-button> -->
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination mt24">
      <el-pagination
        @size-change="onPageSizeChange"
        @current-change="onPageChange"
        :current-page="form.page"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="recordcount"
        :page-size="form.pagesize"
      />
    </div>

    <assign-dialog
      :visible.sync="assignVisible"
      :item="assignItem"
      @success="assignSuccess"
      :orderType="orderType"
    />
  </pack>
</template>

<script>
import { mapGetters } from 'vuex';
import ZtFormItem from '@cps/ZtFormItem';
import datePickerMixins from './mixins/datePicker';
import { dateYMD } from '@/filters/date';
import {
  taoke_order_list,
  taoke_order_settle,
  taoke_ddk_order_settle,
  taoke_ddk_order_list,
  taoke_jd_order_list,
  taoke_jd_order_settle
} from '@/api/finance';
import taoke_duomai_order_list from '@/api/taoke_duomai_order_list'
import taoke_duomai_order_settle from '@/api/taoke_duomai_order_settle'
import AssignDialog from './components/AssignDialog';


export default {
  name: 'FinanceOrder',
  mixins: [datePickerMixins],
  components: {
    ZtFormItem,
    AssignDialog,
  },

  filters: {
    // 小数转百分比
    toPercentum: (val) => (val * 100).toFixed(2),

    // 保留两位小数, 默认2位
    toFixed: (val, x = 2) => (val - 0).toFixed(x),
  },

  data: () => ({
    orderType: 'taobao',
    //商品种类切换
    typeTabList: [
      {
        name: 'taobao',
        title: '淘宝',
        icon: 'icon_taobao',
        hover: false,
      },
      {
        name: 'pdd',
        title: '拼多多',
        icon: 'icon_pdd',
        hover: false,
      },
      {
        name: 'jd',
        title: '京东',
        icon: 'icon_jd',
        hover: false,
      },
      {
        name: 'duomai',
        title: '多麦',
        icon: 'ic_duomai',
        hover: false,
      },
    ],

    date: null,
    list: [],
    formLoading: false,
    tableLoading: false,

    form: {
      create_time_begin: '', // 起始时间
      create_time_end: '', // 结束时间
      telephone: '', // 手机号
      trade_id: '', // 淘宝订单号
      page: 1,
      pagesize: 10,
    },
    recordcount: 0, // 总条数

    // tab切换
    tabItems: [
      { cn: '所有订单', count: 0, tk_status: '' },
      { cn: '已付款', count: 0, tk_status: '12' },
      { cn: '已结算', count: 0, tk_status: '3' },
    ],
    taobaoTabItems: [
      { cn: '所有订单', count: 0, tk_status: '' },
      { cn: '已付款', count: 0, tk_status: '12' },
      { cn: '已结算', count: 0, tk_status: '3' },
    ],
    pddTabItems: [
      { cn: '所有订单', count: 0, tk_status: '' },
      { cn: '已付款', count: 0, tk_status: '12' },
      { cn: '已结算', count: 0, tk_status: '3' },
      { cn: '已失效', count: 0, tk_status: '10' },
    ],
    jdTabItems: [
      { cn: '所有订单', count: 0, tk_status: '' },
      { cn: '已付款', count: 0, tk_status: '12' },
      { cn: '已结算', count: 0, tk_status: '3' },
      { cn: '已失效', count: 0, tk_status: '10' },
    ],
    duomaiTabItems: [
      { cn: '所有订单', count: 0, tk_status: '' },
      { cn: '已付款', count: 0, tk_status: '1' },
      { cn: '已结算', count: 0, tk_status: '2' },
      { cn: '已失效', count: 0, tk_status: '-1' },
    ],

    // 指派弹框
    assignVisible: false,
    assignItem: {},
  }),
  computed: {
    ...mapGetters(['user_info']),

    // 当前vip等级:   1 导购版 2用户中心版 3返利代理版 4尊享版
    vip: (vm) => vm.user_info.vip,

    current: (vm) => vm.$store.state.tabs.financeOrderTabs,
  },

  watch: {
    'form.telephone'(val) {
      if (val.indexOf(' ') !== -1) {
        this.form.telephone = this.form.telephone.replace(/\s+/g, '');
      }
    },
    'form.trade_id'(val) {
      if (val.indexOf(' ') !== -1) {
        this.form.trade_id = this.form.trade_id.replace(/\s+/g, '');
      }
    },
    date(val) {
      const begin = val.length ? dateYMD(val[0]) + ' 00:00:00' : '';
      const end = val.length ? dateYMD(val[1]) + ' 23:59:59' : '';
      this.form.create_time_begin = begin;
      this.form.create_time_end = end;
    },
  },

  methods: {
    //获取api
    async getApi(form) {
      if (this.orderType == 'pdd') {
        const data = await taoke_ddk_order_list(form);
        return data;
      } else if (this.orderType == 'taobao') {
        const data = await taoke_order_list(form);
        return data;
      } else if (this.orderType == 'jd') {
        const data = await taoke_jd_order_list(form);
        return data;
      } else if (this.orderType == 'duomai') {
        const data = await taoke_duomai_order_list(form);
        return data;
      }
    },

    //订单类型切换
    typeTabChange(item) {
      if (item.name == 'pdd') {
        this.tabItems = [];
        this.tabItems.push(...this.pddTabItems);
      } else if (item.name == 'taobao') {
        this.tabItems = [];
        this.tabItems.push(...this.taobaoTabItems);
      } else if (item.name == 'jd') {
        this.tabItems = [];
        this.tabItems.push(...this.jdTabItems);
      } else if (item.name == 'duomai') {
        this.tabItems = [];
        this.tabItems.push(...this.duomaiTabItems);
      }
      this.orderType = item.name;
      this.$store.dispatch('ChangeTabs', {
        name: 'financeOrderTabs',
        current: '0',
      });
      this.form.tk_status = this.tab2status(0);
      this.form.page = 1;
      this.onSubmit();
    },

    // 日期切换
    onDatePickerChange() {
      this.onSubmit();
    },

    // 搜索
    async onSubmit() {
      this.formLoading = true;
      this.form.page = 1;
      await this.getList();
      let formOder = {};
      //更新搜索数量
      this.tabItems.forEach(async(o) => {
        Object.assign(formOder, this.form, {
          tk_status: o.tk_status,
          pagesize: 1,
        });
        const { data } = await this.getApi(formOder);
        o.count = data.recordcount;
      });

      this.formLoading = false;
    },

    // 重置表单
    onReset() {
      this.form.telephone = '';
      this.form.trade_id = '';
      this.date = [];
      this.form.create_time_begin = '';
      this.form.create_time_end = '';
      this.onSubmit();
    },
    //获取提前结算接口
    async getOrderSettle(param) {
      if (this.orderType == 'taobao') {
        const res = await taoke_order_settle(param);
        return res;
      } else if (this.orderType == 'pdd') {
        const res = await taoke_ddk_order_settle(param);
        return res;
      } else if (this.orderType == 'jd') {
        const res = await taoke_jd_order_settle(param);
        return res;
      } else if (this.orderType == 'duomai') {
        const res = await taoke_duomai_order_settle(param);
        return res;
      }
    },
    // 提前结算
    onSettlement(row) {
      this.$msgbox({
        title: '操作提醒',
        customClass: 'long-messagebox',
        message: (
          <div>
            <el-form label-width="120px" label-position="left">
              <el-form-item label="商品名称">{row.item_title}</el-form-item>
            </el-form>
            <p class="gray">对应金额会直接入账，是否提前结算？该操作无法撤回</p>
          </div>
        ),
        beforeClose: async(action, instance, next) => {
          if (action === 'cancel') return next();

          instance.confirmButtonLoading = true;
          const { data } = await this.getOrderSettle({ id: row.id });
          if (data.error_code == 0) {
            this.$message.success('结算成功');
            // 如果结算的是某页的最后一条
            if ((this.list.length = 1 && this.form.page > 1)) {
              this.form.page = this.form.page - 1;
            }
            this.getList();
            this.getCounts();
            next();
          } else {
            this.$message.error(data.error_message);
          }
          instance.confirmButtonLoading = false;
        },
      }).catch(() => {});
    },
    // 指派
    onAssignItem(row) {
      this.assignItem = { ...row };
      this.assignVisible = true;
    },
    // 指派成功事件
    async assignSuccess() {
      this.formLoading = true;
      await this.getList();
      this.formLoading = false;
    },

    // tab改变
    onTabChange(e) {
      this.$store.dispatch('ChangeTabs', {
        name: 'financeOrderTabs',
        current: e.index,
      });
      this.form.tk_status = this.tab2status(e.index);
      this.form.page = 1;
      this.getList();
    },

    // 分页器页面大小改变
    onPageSizeChange(pagesize) {
      this.form.pagesize = pagesize;

      // 当前页数*当前页面大小 > 数据总数 的时候不发请求(由onPageChange发请求)
      if (this.form.page * pagesize > this.recordcount && this.form.page != 1)
        return;

      // 发请求
      this.getList();
    },
    // 分页器页数改变
    onPageChange(page) {
      this.form.page = page;
      this.getList(true);
    },

    // tab索引转订单状态
    tab2status(current) {
      let tabItems = null
      switch(this.orderType) {
      case 'taobao': tabItems = this.taobaoTabItems; break;
      case 'pdd': tabItems = this.pddTabItems; break;
      case 'jd': tabItems = this.jdTabItems; break;
      case 'duomai': tabItems = this.duomaiTabItems; break;
      }
      if (tabItems[current]) {
        return tabItems[current].tk_status
      }
      else {
        return ['', '12', '3', '10'][current - 0]
      }
    },
    // 订单状态转中文
    status2cn(row) {
      // row可以是对象也可以是一个状态
      let status = row instanceof Object ? row.tk_status : row;

      if (this.orderType === 'duomai') {
        return {
          '-1': '无效',
          0: '未确认',
          1: '确认',
          2: '结算',
        }[status]
      }

      return {
        3: '已结算',
        12: '已付款',
        13: '已失效',
        14: '已成功',
        10: '已失效',
      }[status];
    },

    // 获取数据
    async getList(toTop) {
      if (this.tableLoading) return;

      this.tableLoading = true;

      const { data } = await this.getApi(this.form);

      if (data.error_code != 0) {
        this.$message.error(data.error_message);
      } else {
        this.list = data.list;
        this.list.map(function(list) {
          //拆分日期
          if (list.create_time != '' && list.create_time != undefined) {
            list.create_time_ymd = list.create_time.split(' ')[0];
            list.create_time_hms = list.create_time.split(' ')[1];
          }
          if (list.commission_time != '' && list.commission_time != undefined) {
            list.commission_time_ymd = list.commission_time.split(' ')[0];
            list.commission_time_hms = list.commission_time.split(' ')[1];
          } else {
            list.commission_time_ymd = '-';
            list.commission_time_hms = '';
          }
        });
        this.recordcount = data.recordcount;
        if (toTop) {
          window.scrollTo(0, 0);
        }
      }

      this.tableLoading = false;

      return data;
    },

    // 获取三个状态的订单数量
    async getCounts() {
      this.tabItems.forEach(async(o) => {
        const { data } = await this.getApi({
          tk_status: o.tk_status,
          pagesize: 1,
        });
        o.count = data.recordcount;
      });
    },
  },

  created() {
    this.getCounts();
    const { telephone } = this.$route.query;
    this.form.tk_status = this.tab2status(this.current);
    this.form.telephone = telephone || '';
    if (telephone) {
      this.form.tk_status = '';
      this.$store.dispatch('ChangeTabs', {
        name: 'financeOrderTabs',
        current: '0',
      });
    }
    this.onSubmit();
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/table.scss";
/deep/ .el-table .cell {
  text-align: center;
}
.el-date-editor {
  width: 340px;
}

.pagination {
  text-align: right;
}
.tab-box {
  display: inline-block;
  margin-right: 16px;
}
.typeTab {
  padding-bottom: 9px;
  margin-bottom: 19px;
  border-style: solid;
  border-width: 0 0 1px 0;
  border-color: #dcdfe6;
  .tab-item {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 156px;
    height: 60px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 22px;
    .svg-icon {
      font-size: 32px;
      margin-right: 12px;
    }
  }
  .taobao {
    color: #ff4400;
    border: 1px solid rgba(254, 122, 66, 1);
  }
  .pdd {
    color: #f40009;
    border: 1px solid rgba(244, 0, 9, 1);
  }
  .jd {
    color: #e31d19;
    border: 1px solid rgba(227, 29, 25, 1);
  }
  .duomai {
    border: 1px solid #FF9200;
    color: #FF9200;
  }
  .taobao-hover {
    &:hover {
      color: #ff4400;
      border: 1px solid rgba(254, 122, 66, 1);
    }
  }
  .pdd-hover {
    &:hover {
      color: #f40009;
      border: 1px solid rgba(244, 0, 9, 1);
    }
  }
  .jd-hover {
    &:hover {
      color: #e31d19;
      border: 1px solid rgba(227, 29, 25, 1);
    }
  }
  .duomai-hover {
    &:hover {
      border: 1px solid #FF9200;
      color: #FF9200;
    }
  }
}
</style>